export function SET_DELIVERY_DATA(payload) {
	return {
		type: 'SET_DELIVERY_DATA',
		payload: payload,
	};
}